import api from '@/config/api'
import type { ApiResponse } from '@/shared/types/api'
import type { User, LoginCredentials, ChangePasswordCredentials } from '@/shared/types/auth'

interface LoginResponseData {
  token: string
  refreshToken: string
  user: User
}

interface RefreshResponseData {
  token: string
  refreshToken: string
}

export async function loginApi(credentials: LoginCredentials): Promise<ApiResponse<LoginResponseData>> {
  const response = await api.post<ApiResponse<LoginResponseData>>('/auth/login', credentials)
  return response.data
}

export async function getCurrentUserApi(): Promise<User> {
  const response = await api.get<ApiResponse<User>>('/api/users/me')
  return response.data.data || response.data
}

export async function updateCurrentUserApi(formData: FormData): Promise<User> {
  const response = await api.put<ApiResponse<User>>('/api/users/me', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return response.data.data || response.data
}

export async function changePasswordApi(credentials: ChangePasswordCredentials): Promise<ApiResponse<LoginResponseData>> {
  const response = await api.post<ApiResponse<LoginResponseData>>('/api/users/change-password', credentials)
  return response.data
}

export async function forgotPasswordApi(email: string): Promise<ApiResponse<void>> {
  const response = await api.post<ApiResponse<void>>('/auth/forgot-password', { email })
  return response.data
}

export async function resetPasswordApi(token: string, newPassword: string): Promise<ApiResponse<void>> {
  const response = await api.post<ApiResponse<void>>('/auth/reset-password', { token, newPassword })
  return response.data
}

export async function refreshTokenApi(refreshToken: string): Promise<ApiResponse<RefreshResponseData>> {
  const response = await api.post<ApiResponse<RefreshResponseData>>('/auth/refresh', { refreshToken })
  return response.data
}

export async function logoutApi(refreshToken: string): Promise<void> {
  await api.post('/auth/logout', { refreshToken })
}
